<div class="prompt-area">
    <div class="wysiwyg">
        <richtext placeholder="{{placeholder}}" [(value)]="prompt" (valueChange)="onChange($event)">
        </richtext>
    </div>
</div>